export const getRandomNumber = () => {
  return Math.random().toString().split('.')[1];
};
